import mailTemplateService from '../../../services/mailTemplate.service';

export default {
  async getListMailTemplate({ dispatch, commit }, data) {
    return await mailTemplateService.getListMailTemplate(data)
      .then(response => {
        if (response.success && response.data) {
          const listMailTemplate = response.data
          commit("SET_LIST_MAIL_TEMPLATE", listMailTemplate)
          return Promise.resolve(response.data);
        } else {
          commit("SET_LIST_MAIL_TEMPLATE", [])
          dispatch("alertError", response.message, { root: true });
          return Promise.reject(response.message);
        }
      }).catch(error => {
        commit("SET_LIST_MAIL_TEMPLATE", [])
        return Promise.reject(false);
      })
  },

  async deleteMailTemplate({ dispatch, commit }, data) {
    return await mailTemplateService.deleteMailTemplate(data)
      .then(response => {
        if (response.success) {
          return Promise.resolve(response.data);
        } else {
          dispatch("alertError", response.message, { root: true });
          return Promise.reject(response.message);
        }
      }).catch(error => {
        dispatch("alertError", error.message, { root: true });
        return Promise.reject(false);
      })
  },

  async addMailTemplate({ dispatch, commit }, data) {
    return await mailTemplateService.addMailTemplate(data)
      .then(response => {
        if (response.success) {
          dispatch("alertSuccess", response.message, { root: true });
          return Promise.resolve(response.data);
        } else {
          dispatch("alertError", response.message, { root: true });
          return Promise.reject(response.message);
        }
      }).catch(error => {
        dispatch("alertError", error.message, { root: true });
        return Promise.reject(false);
      })
  },
}